<div class="tabs semi-bold">
  <app-section *ngIf="!formTab">
    <span
    *ngFor="let tab of tabs; let i = index;"
    [ngClass]="[!showSubTab && i === selected ? 'selected': !showSubTab && tab.disable ? 'disable': '', showSubTab && i === selected ? 'subTabSelected': tab.disable ? 'disable': showSubTab ? 'subTabUnSelected' : '', tab.textTransformNone? 'text-transform-none':'']"
    (click)="onSelect(i, true)"
    >{{tab.name}}<p *ngIf="showCount" class="count"> ({{tab.count}})</p></span>
  </app-section>
  <div *ngIf="formTab">
    <span
      *ngFor="let tab of tabs; let i = index;"
      [ngClass]="[i === selected ? 'selected': tab.disable ? 'disable': '', tab.textTransformNone? 'text-transform-none':'']"
      (click)="onSelect(i, true)"
      >{{tab.name}}</span>
  </div>
</div>
